import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import Card from '../../../components/common/cards/index';
// import image1 from "../../../assests/images/image1.png";
// import image2 from "../../../assests/images/images2.png";
// import image3 from "../../../assests/images/image3.png";
// import image4 from "../../../assests/images/image4.png";
// import image5 from "../../../assests/images/image5.png";
// import image6 from "../../../assests/images/image6.png";
import image1 from "../../../assests/wood-image/products/All-CNC-Works/image-1.png";
import image2 from "../../../assests/wood-image/products/All-CNC-Works/image-2.png";
import image3 from "../../../assests/wood-image/products/All-CNC-Works/image-3.png";
import image4 from "../../../assests/wood-image/products/All-CNC-Works/image-4.png";
import image5 from "../../../assests/wood-image/products/All-CNC-Works/image-5.png";
import image6 from "../../../assests/wood-image/products/All-CNC-Works/image-6.png";
import image7 from "../../../assests/wood-image/products/All-CNC-Works/image-7.png";
import image8 from "../../../assests/wood-image/products/All-CNC-Works/image-8.png";
import image9 from "../../../assests/wood-image/products/All-CNC-Works/image-9.png";
import '../products.css';
const CNC = () => {
    const productData = [
        { id: 1, name: 'Modern Double Door', price: '$199.99', shortDescription: 'A stylish modern door for your home.', image: image1 },
        { id: 2, name: 'CNC Window', price: '$89.99', shortDescription: 'A comfortable wooden chair for your living room.', image: image2 },
        { id: 3, name: 'Intricate Table Top', price: '$299.99', shortDescription: 'A beautiful table made from high-quality wood.', image: image3 },
        { id: 4, name: 'Ornate Wall Panel', price: '$149.99', shortDescription: 'A spacious bookshelf to organize your books.', image: image4 },
        { id: 5, name: 'Classic Cabinet Front', price: '$399.99', shortDescription: 'A classic cabinet with ample storage space.', image: image5 },
        { id: 6, name: 'Ornate Wall Decoration', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image6 },
        { id: 7, name: 'Floral Wall Decoration', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image7 },
        { id: 8, name: 'Single Door', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image8 },
        { id: 9, name: 'Double Door', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image9 },
    ];

    return (
        <div className="container mt-0 " style={{padding:'120px 10px '}}>
            <div className="banner animate__animated animate__bounceIn py-5" >
                <h1>Exclusive Offers on CNC</h1>
                <p>Up to 50% off on selected items!</p>
                <div className="icons">
                    <FontAwesomeIcon icon={faTag} className="icon" />
                    <FontAwesomeIcon icon={faShoppingCart} className="icon" />
                </div>
                <div className='text-center' id='doors'><a href='#doors' className="btn btn-danger" style={{width:'200px'}}>Shop Now</a></div>
                
            </div>
            <h2 className="my-4" >CNC Products</h2>
            <div className="row" >
                {productData.map(product => (
                    <div key={product.id} className="col-lg-4 col-md-6 mb-4">
                        <Card 
                            image={product.image} 
                            // name={product.name} 
                            // price={product.price} 
                            // shortDescription={product.shortDescription} 
                            productId={product.id}
                            title="CNC Works" 
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CNC;
